<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    items: (menuItems$ | async) ?? []
  }"
  >
</ng-container>

<ng-template #template let-items="items">
  @if (!menuOption) {
    <div flex flexLayout="row" flexLayoutAlign="start stretch">
      @for (item of items; track item) {
        <div
          class="menu-item"
          flexLayout="column"
          flexLayoutAlign="center center"
          routerLinkActive="active"
          [routerLink]="item.routerLink"
          >
          {{ item?.displayName }}
          @if (menuOption) {
            <mat-divider></mat-divider>
          }
        </div>
      }
    </div>
  }
  @if (menuOption) {
    <div flex flexLayout="row" flexLayoutAlign="start stretch">
      @for (item of items; track item) {
        <div
          class="menu-item"
          flexLayout="row"
          flexLayoutAlign="start center"
          [routerLink]="item.routerLink"
          >
          <div flexAlign="center">{{ item?.displayName }}</div>
        </div>
      }
    </div>
  }
</ng-template>
